import { SearchTwoTone } from '@mui/icons-material';
import { Box, ButtonBase, CircularProgress, IconButton, InputBase, List, ListItem, ListItemText, ListItemAvatar, ListItemButton, Avatar, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Spinner } from '../../layouts';
import { httpClient } from '../../utils';

async function fetchMeals() {
  try {
    const {data} = await httpClient.get('meals');
    return data;
  } catch (error) {
    throw error;
  }
}

const SearchMeals = (props) => {

  const { addMeal } = props;

  const {data, status} = useQuery('meals', fetchMeals);

  const [keyword, setKeyword] = useState('');
  const [searchList, setSearchList] = useState(undefined);

  useEffect(() => {
    if (data) {
      setSearchList(data.filter(x => x.mealName.toLowerCase().includes(keyword.toLowerCase())))
    }
  }, [keyword]);

  if (status === 'idle' || status === 'loading') return (
    <Spinner />
  )

  if (status === 'error') return (
    <Box textAlign={'center'} color={'red'} >
      Error
    </Box>
  )

  if (status === 'success') return (
    <>
      <Paper sx={{ display:'flex', alignItems:'center', padding:'0px 4px' }} >
        <InputBase
          sx={{ flex:1, marginLeft: '12px' }}
          placeholder='Search Meals'
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <IconButton >
          <SearchTwoTone />
        </IconButton>
      </Paper>
        <List sx={{ marginTop:'8px', maxHeight:350, overflow:'auto' }} >
          {
            searchList ? searchList.map((meal, index) => (
              <ListItem key={index} >
                <ListItemButton onClick={() => addMeal(meal)} >
                  <ListItemText 
                    primary={meal.mealName}
                    secondary={`${meal.mealPrice} DH`}
                  />
                  <ListItemAvatar>
                    <Avatar alt={meal.mealName} src={meal.image} />
                  </ListItemAvatar>
                </ListItemButton>
              </ListItem>
            )) : data.map((meal, index) => (
              <ListItem key={index} >
                <ListItemButton onClick={() => addMeal(meal)} >
                    <ListItemText
                      sx={{textAlign:'left'}}
                      primary={meal.mealName}
                      secondary={`${meal.mealPrice} DH`}
                    />
                    <ListItemAvatar>
                      <Avatar alt={meal.mealName} src={meal.image} />
                    </ListItemAvatar>
                </ListItemButton>
              </ListItem>
            ))
          }
        </List>
    </>
  )
}

export default SearchMeals